import { SocketContext } from 'app/providers/SocketProvider';
import { useContext, useEffect } from 'react';
import { SocketClientMessage } from '@okletsplay/core';

interface SocketSubscription<Params> {
  action: SocketClientMessage;
  handler: (args: Params) => void;
}

export function useSocketSubscriber<Params>(subscriptions: SocketSubscription<Params>[]) {
  const { socket } = useContext(SocketContext);

  useEffect(() => {
    subscriptions.forEach((subscription) => {
      socket?.on(subscription.action, subscription.handler);
    });

    return () =>
      subscriptions.forEach((subscription) =>
        socket?.off(subscription.action, subscription.handler)
      );
  }, [socket, subscriptions]);
}
